import { DateFormats, formatDate, formatPhoneNumber } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import {
    AddressDetailLabelValue,
    DetailLabel,
    DetailLabelValuePair,
} from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

import { FaxStatusIndicator } from 'components/shared/FaxStatusIndicator';

export const PrescriberDetails = ({
    prescriberDetails = undefined,
    prescriberFaxPref = undefined,
    referralFaxStatus = undefined,
    isLoading = true,
    // eslint-disable-next-line complexity
}) => (
    <FormSectionWithRows
        sectionTitle="Prescriber Details"
        width="100%"
        isLoading={isLoading}
        rowOneContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Name"
                    value={prescriberDetails?.prescriberName || 'Missing Prescriber'}
                />
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Prescriber NPI"
                    value={prescriberDetails?.prescriberNpi}
                />
            </>
        }
        rowTwoContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Phone"
                    value={formatPhoneNumber(prescriberDetails?.prescriberPhone)}
                />
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Fax"
                    value={formatPhoneNumber(prescriberDetails?.prescriberFax)}
                />
            </>
        }
        rowThreeContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Point of Contact"
                    value={prescriberDetails?.pointOfContactName}
                />
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Point of Contact Phone"
                    value={formatPhoneNumber(prescriberDetails?.pointOfContactPhone)}
                />
            </>
        }
        rowFourContent={
            <>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Practice"
                    value={prescriberDetails?.practice}
                />
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Practice NPI"
                    value={prescriberDetails?.practiceNpi}
                />
            </>
        }
        rowFiveContent={
            <AddressDetailLabelValue
                label="Practice Address"
                address1={prescriberDetails?.address1}
                address2={prescriberDetails?.address2}
                city={prescriberDetails?.city}
                state={prescriberDetails?.state}
                zip={prescriberDetails?.zip}
            />
        }
        rowSixContent={
            <>
                <div style={{ width: '50%' }}>
                    <DetailLabel label="Last Fax Status" />
                    <FaxStatusIndicator
                        canSendFax={!!prescriberDetails?.prescriberFax}
                        faxPrefOptionValue={prescriberFaxPref?.option_value}
                        faxStatus={referralFaxStatus?.prescriber}
                    />
                </div>
                <DetailLabelValuePair
                    style={{ width: '50%' }}
                    label="Last Fax Sent"
                    value={formatDate(
                        referralFaxStatus?.prescriber?.date_sent,
                        DateFormats.DATE_TIME,
                    )}
                />
            </>
        }
    />
);
PrescriberDetails.propTypes = {
    prescriberDetails: PropTypes.shape({
        prescriberName: PropTypes.string,
        prescriberPhone: PropTypes.string,
        prescriberFax: PropTypes.string,
        pointOfContactName: PropTypes.string,
        pointOfContactPhone: PropTypes.string,
        prescriberNpi: PropTypes.string,
        practice: PropTypes.string,
        practiceNpi: PropTypes.string,
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
    prescriberFaxPref: PropTypes.shape({
        option_value: PropTypes.string.isRequired,
    }),
    referralFaxStatus: PropTypes.shape({
        prescriber: PropTypes.shape({
            message: PropTypes.string,
            status: PropTypes.string,
            date_sent: PropTypes.string,
            tooltip: PropTypes.string,
        }),
    }),
};
